import React, { ReactElement } from 'react';
import './Rules.scss';

const Et: React.FC = (): ReactElement => {
  return (
    <div className="Et rules-wrapper">
      <h2>KAMPAANIAREEGLID</h2>
      <ol>
        <li>
          Kampaania <span className="bold">“Anna kiusatusele järele”</span> on
          alates <span className="bold">01.09.2026</span> kuni{' '}
          <span className="bold">30.09.2026</span> toimuv tarbijamäng (edaspidi
          kampaania), mida korraldab Fazer Eesti OÜ, (asukoht: Pärnu maantee
          158/1, Tallinn; edaspidi korraldaja).
        </li>
        <li>
          Kampaania auhinnafondi{' '}
          <span className="bold">
            kuulub 2x Sony PlayStation 5 Pro ja 5x Sony WH-CH720N juhtmevabad
            kõrvaklapid,{' '}
          </span>{' '}
          mis loositakse välja 01.10.2026. Auhinnafondi koguväärtus on
          2500€.{' '}
        </li>
        <li>
          Kampaania läbiviimise kord on kehtestatud korraldaja poolt
          käesolevates reeglites. Kõik korraldaja otsused kampaania läbiviimisel
          on lõplikud ning kõigile kampaanias osalejatele kohustuslikud.
        </li>

        <li>
          Kampaaniatooted:
          <ul>
            <li>6416453095014 Karl Fazer piimašokolaad 180g</li>
            <li>
              6411401015151 Karl Fazer piimašokolaad tervete metspähklitega 200g
            </li>
            <li>6416453095120 Karl Fazer piimašokolaad pähkli-rosina 180g</li>
            <li>6416453095052 Karl Fazer tume šokolaad 180g</li>
            <li>
              6416453014381 Karl Fazer piimašokolaad Dumle toffeetükkidega 180g
            </li>
            <li>
              6416453014442 Karl Fazer piimašokolaad soolase karamelli tükkidega
              180g
            </li>
            <li>
              6416453014732 Karl Fazer piimašokolaad mündimaitselise
              mandlikrokandiga 180g
            </li>
            <li>
              6416453014695 Karl Fazer American lentils piimašokolaad
              šokolaadidražeedega 180g
            </li>
            <li>
              6416453014794 Karl Fazer piimašokolaad punaste marjadega 180g
            </li>
            <li>6416453054813 Karl Fazer piimašokolaad vanilje-iirise 180g</li>
            <li>6416453095137 Karl Fazer Remix piimašokolaad 180g</li>
            <li>6416453015630 Karl Fazer valge - ja piimašokolaad 131g</li>
            <li>6416453095199 Karl Fazer Suffeli Salty piimašokolaad 160g</li>
            <li>
              6416453056114 Karl Fazer piimašokolaad purustatud metsapähklitega
              95g
            </li>
            <li>
              6416453056169 Karl Fazer piimašokolaad piparmünditükikestega 95g
            </li>
            <li>6416453056176 Karl Fazer piimašokolaad 95g</li>
            <li>
              6411401019067 Karl Fazer piima- ja valge šokolaadibatoon 38g
            </li>
            <li>6411401019012 Karl Fazer piimašokolaadibatoon 39g</li>
            <li>6411401019081 Karl Fazer Tume šokolaadibatoon 39g</li>
            <li>6416453017405 Karl Fazer Crunchy šokolaadibatoon 55g</li>
            <li>6416453020436 Karl Fazer Crunchy Vaarika 50g</li>
            <li>6416453057067 Karl Fazer Choco & Salty Bites 94g bag</li>
            <li>6416453057234 Karl Fazer Nutty Nougat Crunchy Bites 94g</li>
            <li>6416453072633 Karl Fazer Dark 70% kommikarp 150g</li>
            <li>6416453072640 Karl Fazer piimašokolaadikompvekid 150g</li>
            <li>6416453072657 Karl Fazer Selection kommikarp 150g</li>
            <li>6416453053113 Karl Fazer piimašokolaadikompvekid 250g</li>
            <li>
              6416453053144 Karl Fazer piimašokolaadikompvekid mustikatäidisega
              250g
            </li>
            <li>
              6416453053199 Karl Fazer piimašokolaadikompvekid
              vaarikajogurtitäidisega 250g
            </li>
            <li>6411404021036 Karl Fazer piimašokolaadikompvekid 3kg</li>
          </ul>
        </li>
        <li>
          <p className="bold">
            Kampaanias osalemiseks tuleb osta vähemalt üks Karl Fazer toode ja
            registreerida ostutšekk interneti kaudu kampaanialehel www.fazer.ee.
            Kampaanias osalemine on tasuta. Auhinna kättesaamiseks tuleb
            kampaania korraldajale esitada ostutšekk.
          </p>

          <p>
            Loosimises osalemiseks võib ühe ostutšeki numbri esitada ainult ühe
            korra. Sama ostutšeki mitmekordsel registreerimisel osaleb ainult
            esimesena saabunud registreering.
          </p>
          <p className="bold">Isikuandmete töötlemise kord</p>
          <p>
            Fazer Eesti OÜ töötleb kampaania käigus osaleja poolt esitatud
            isikuandmeid vastavalt Eesti Vabariigis kehtivatele seadustele
            kampaania läbiviimise eesmärgil.
          </p>
          <p>
            Kampaanias osaleja annab Fazer Eesti OÜ-le nõusoleku töödelda
            esitatud andmeid järgnevatel eesmärkidel:
            <ul>
              <li>kampaania tulemuste kohta kokkuvõtete tegemiseks; </li>
              <li>kampaaniaga seotud koostööpartneritele info edastamiseks;</li>
              <li>võitjate välja loosimiseks ja nende teavitamiseks;</li>
              <li>võitjate nimede avaldamiseks kampaania veebilehel.</li>
            </ul>
          </p>
          <p>
            Kampaanias osalejatel on õigus saada lisainfot Fazer Eesti OÜ poolt
            isikuandmete töötlemise kohta. Selleks tuleb saata e-kiri
            aadressile: <a href="mailto:info@fazer.ee">info@fazer.ee</a>{' '}
          </p>
          <p>
            Isikuandmete vastutav töötleja on Fazer Eesti OÜ, registrikood
            10057691, Pärnu maantee 158/1, Tallinn 11317; tel 6502421;{' '}
            <a href="mailto:info@fazer.ee">info@fazer.ee</a>
          </p>
          <p>
            Kogutud andmeid säilitatakse kolm kuud alates kampaania
            lõpukuupäevast ehk kuni 31.12.2026. Võitjate täielik nimekiri on
            veebilehel üleval kuni 31.10.2026.{' '}
          </p>
        </li>
        <li>
          <p>
            <span className="bold">01.10.2026</span> loositakse kell 12.00
            kõikide kampaanias osalejate vahel välja{' '}
            <span className="bold">
              2x Sony PlayStation 5 Pro ja 5x Sony WH-CH720N juhtmevabad
              kõrvaklapid. Auhinnafondi koguväärtus on 2500€.
            </span>
          </p>
          <p>
            Auhinna loosimises osalevad kõik veebis registreerunud isikud
            kampaania reeglites esitatud perioodil (alates keskkonna
            avanemisest). Võitjat informeeritakse telefoni või meili teel.
            Loosimise juures viibib vähemalt üks Fazer Eesti OÜ esindaja.
          </p>
        </li>
        <li>
          Auhinna võitja nimi avaldatakse internetis aadressil{' '}
          <a href="http://www.fazer.ee">www.fazer.ee</a> hiljemalt loosimisele
          järgneval kolmandal tööpäeval. Võitjaga võetakse korraldaja esindaja
          poolt ühendust andmete ja auhinna kättetoimetamisviisi täpsustamiseks.
        </li>
        <li>
          {' '}
          Juhul, kui auhinna võitja ei vasta korraldaja poolt kehtestatud
          kampaania tingimustele või kui ta ei ole alles hoidnud toote
          ostutšekki, millel oleva numbri ta edastas kampaania korraldajale
          veebi vahendusel, on õigus auhind uuesti välja loosida järgmisele
          isikule. Samuti juhul, kui auhinna võitja ei ole hiljemalt nädala
          jooksul alates, tema kui auhinna võitja nime avalikustamist internetis
          aadressil www.fazer.ee olnud veebis esitatud kontaktandmetel
          kättesaadav andmete täpsustamiseks, on korraldajal õigus jätta talle
          auhind üle andmata ning korraldada uus loosimine.
        </li>
        <li>
          Korraldajalt ükskõik missuguse kampaania auhinna saaja annab loa
          korraldajale kasutada võitja nime meedias, reklaamides,
          PR-kampaaniates jms üritustel ilma võitjale selle eest täiendavat tasu
          maksmata ja vastavat kokkulepet sõlmimata.
        </li>
        <li>
          Kampaania käigus kampaanias osaleja poolt võidetud auhinda ei asendata
          võitja nõudmisel teist liiki auhinnaga ega hüvitata võitjale auhinna
          maksumust rahas, v.a juhul, kui auhind asendatakse teise samaväärse
          auhinnaga korraldaja otsusel.{' '}
        </li>
        <li>
          Auhinna võitjale üleandmisega seotud riiklikud maksud tasub korraldaja
          Eesti Vabariigi seadustes sätestatud korras ja tähtaegadel.{' '}
        </li>
        <li>
          Kampaanias osaleja poolt kampaania tingimuste eiramise või
          korraldajale enda kohta valede või ebatäpsete andmete esitamise
          korral, samuti muude ebaõnnestumiste korral (korraldajal ei õnnestu
          auhinna võitjaga kontakti saada), mis ei ole tingitud korraldaja
          süüst, ei vastuta korraldaja kampaanias osaleja auhindade loosimisest
          või auhinna kätteandmisest kõrvalejäämise eest.{' '}
        </li>
        <li>
          Vääramatu jõu (force majeure) asjaolude ilmnemisel on korraldajal
          ühepoolne õigus katkestada kampaania ja jätta auhinnad välja loosimata
          ja/või auhinnad võitjatele üle andmata, teatades sellest koheselt
          kampaanias osalejatele meedia vahendusel.{' '}
        </li>
        <li>
          Kõik kampaaniast tulenevad vaidlused lahendatakse vastavalt Eesti
          Vabariigi seadusandlusele.
        </li>
        <li>
          Kõik pretensioonid seoses kampaania korraldamise ja/või läbiviimisega
          tuleb saata kirjalikult kampaania korraldaja asukohta: Pärnu maantee
          158/1, 11317 Tallinn märksõnaga{' '}
          <span className="bold">“KAMPAANIA"</span> hiljemalt 01.10.2026.
          Kaebused, mis esitatakse peale nimetatud kuupäeva, ei võeta
          menetlusse. Laekunud pretensioonidele vastatakse 3 tööpäeva jooksul.
          Kampaania lisainfo telefonil 650 2421;{' '}
          <a href="mailto:info@fazer.ee">info@fazer.ee</a>{' '}
        </li>
      </ol>
    </div>
  );
};

export default Et;
